import { DomainEvent } from '@frontend/sports/common/core/utils/dispatcher';

export interface SubTab {
    id: string;
    name: string;
}
export interface SubNavigationPayload {
    tabId: number;
    subTabs: SubTab[];
}

export const EventNavigation = class {
    static SelectSubTab = new DomainEvent<string>('EVENT_DETAILS_SELECT_SUB_TAB');
    static SetSubTabs = new DomainEvent<SubNavigationPayload>('EVENT_DETAILS_SET_SUB_TABS');
};
